export default __webpack_public_path__ + "static/media/gift.e0e9b6a7.svg";